package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.model.InventoryItem
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.repository.InventoryRepository

class DeleteInventoryItemUseCase(
    private val inventoryRepository: InventoryRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(item: InventoryItem): Result<Unit> {
        if (item.imageUrl != null) {
            imageStorageRepository.delete(ImageTarget.InventoryItem(item.characterId, item.id))
        }

        return inventoryRepository.deleteItem(item.id)
    }
}
